
import React from 'react';

import Promise from 'bluebird';

import PropTypes from 'prop-types';

import _ from 'underscore';
import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';
import { PidlUtilShape } from '../shapes';
import { ResourceTypes } from '../consts';
import type { AddressData, AdderPidlFormPreviousProps, AdderPidlFormProps } from '../types';

// Short Term fix for Netherlands Antilles market

const convertCountry = (country: string) => (country === 'AN' ? 'CW' : country);

export class AdderPidlForm extends React.Component<AdderPidlFormProps> {
  static propTypes = {
    currency: PropTypes.string,
    pidlInstance: PropTypes.shape({
      cancel: PropTypes.func.isRequired,
      addResource: PropTypes.func.isRequired,
    }),
    pidlUtil: PidlUtilShape.isRequired,
    piData: PropTypes.shape({
      Market: PropTypes.string,
      PiType: PropTypes.string,
    }).isRequired,
    pidlFormId: PropTypes.string.isRequired,
    handleProcessingStart: PropTypes.func.isRequired,
    handlePidlLoadingStart: PropTypes.func,
    handlePidlLoadingComplete: PropTypes.func,
  };

  static defaultProps: Partial<AdderPidlFormProps> = {

    pidlInstance: null,

    currency: null,
    handlePidlLoadingStart: _.noop,
    handlePidlLoadingComplete: _.noop,
  };


  addResourceToken?: { cancel(): void };

  componentDidUpdate(prevProps: AdderPidlFormPreviousProps) {
    const country = this.props.piData.Market;
    const piType = this.props.piData.PiType;
    const { currency } = this.props;

    if (this.props.pidlInstance &&
      (
        !prevProps.pidlInstance ||
        country !== prevProps.piData.Market ||
        piType !== prevProps.piData.PiType
      )) {
      this.props.pidlUtil.logger.setPidlOption('Market', country);
      this.props.pidlUtil.logger.setPidlOption('PiType', piType);

      this.props.pidlInstance.cancel();
      let family;
      let type;

      this.props.pidlUtil.enabledCountries.UPI = ['IN'];
      this.props.pidlUtil.piTypes.UPI = 'UPI';
      if (_.contains(this.props.pidlUtil.enabledCountries[piType], country)) {
        this.props.handleProcessingStart();
        switch (piType) {
          case this.props.pidlUtil.piTypes.CreditCard:
            family = 'credit_card';
            type = this.props.pidlUtil.getSupportedCardTypes(country, currency);
            break;
          case this.props.pidlUtil.piTypes.PayPal:
            family = 'ewallet';
            type = 'paypal';
            break;
          case this.props.pidlUtil.piTypes.ELV:
            family = 'direct_debit';
            type = 'sepa';
            break;
          case this.props.pidlUtil.piTypes.UPI:
            family = 'ewallet';
            type = 'legacy_billdesk_payment';
            break;
          default:
            throw new Error('InvalidPIType');
        }

        const pidlDocInfo = {
          resourceType: ResourceTypes.PaymentInstrument,
          parameters: _.extend({
            family,
            type,
            country: convertCountry(country),
          }, this.props.pidlUtil.pidlDocParameters),
        };

        const addressPromise = this.props.pidlUtil.logger.addTaps(
          'addressFetch',
          this.props.pidlUtil.pidlService.getAddressList!({ countryCode: country })
        )
          // catch the error so Promise.all will evaluate this Promise as succeeding instead
          // of fast-failing, if this happens we just won't incorporate the address data
          .catch(_.noop);

        if (this.addResourceToken) {
          this.addResourceToken.cancel();
        }

        this.props.handlePidlLoadingStart();

        this.addResourceToken = createAsyncToken(Promise.all([addressPromise, this.props.pidlUtil.getRiskData()])).on({
          onSuccess: (retVals) => {
            const prefillAddressData = retVals[0];

            const riskData = retVals[1];

            if (prefillAddressData && _.isArray(prefillAddressData)) {
              // eslint-disable-next-line no-param-reassign
              prefillAddressData.forEach((adr: AddressData) => { adr.country = convertCountry(adr.country); });
            }

            this.props.pidlUtil.logger.start('renderPidl');
            this.props.pidlInstance.addResource(pidlDocInfo, prefillAddressData, riskData);

            this.props.handlePidlLoadingComplete();
          },
          onError: () => {
            this.props.handlePidlLoadingComplete();
          },
          onCancel: () => {
            this.props.handlePidlLoadingComplete();
          },
        });
      }
    }
  }

  componentWillUnmount() {
    if (this.addResourceToken) {
      this.addResourceToken.cancel();
    }
  }

  render() {
    return (
      <div className="adder-pidl-form-container">
        <div id={this.props.pidlFormId} />
      </div>
    );
  }
}
